import { FC } from 'react';
import { Card, Flex, Text } from '@qga/roo-ui/components';
import useDetailsBooking from 'hooks/useDetailsBooking';
import { getPendingScheduledPayment } from 'lib/bookingInfo';
import { FormattedMoney, FormattedCalendarDate } from 'components/Formatters';

const DepositPayActions: FC = () => {
  const { booking } = useDetailsBooking();
  const scheduledPayment = getPendingScheduledPayment(booking);
  if (!scheduledPayment) {
    return null;
  }

  const total = scheduledPayment.creditCardPaymentAllocation.allocation;
  const paymentDueDate = scheduledPayment.deferredTo;

  return (
    <Card display="flex" flexDirection="column" textAlign="left" borderRadius="default" p={0} mb={4}>
      <Flex flexDirection="row" justifyContent="space-between" m={4} mb={0}>
        <Text as="div" fontSize="lg">
          Final payment scheduled
        </Text>
        <Text as="div" fontSize="lg" textAlign="right">
          <FormattedMoney {...total} />
        </Text>
      </Flex>
      <Text as="div" m={4} mt={3}>
        Your final scheduled payment of <FormattedMoney {...total} /> is due on <FormattedCalendarDate date={paymentDueDate} />
      </Text>
    </Card>
  );
};

export default DepositPayActions;
